/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailRequest } from '../models/EmailRequest';
import type { EmailResponse } from '../models/EmailResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmailService {
    /**
     * @returns EmailResponse OK
     * @throws ApiError
     */
    public static postApiV1Email({
        requestBody,
    }: {
        requestBody: EmailRequest,
    }): CancelablePromise<EmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns EmailResponse OK
     * @throws ApiError
     */
    public static getApiV1Email(): CancelablePromise<Array<EmailResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Email',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
